import { Platform } from 'react-native';
export const Device = {
    isDevice: false,
    modelName: Platform.OS,
    version: Platform.Version
};
